import REDUX_ACTION from 'modules/redux/constants/action'
import { getObjectUtil } from 'packages/src'

/**
 * Sets the `value` at the given `payload.path`.
 * @param {Object} params
 *        {string} params.path
 *        {String[]} [params.paths]
 *        {string} params.value
 *        {String[]} [params.values]
 *        {Object} [params.options]
 */
function setReduxAction (params) {
  return (dispatch, getState) => {
    const { payload } = params
    const {
      path,
      value
    } = payload
    if (path && getObjectUtil(getState(), path) === value) {
      return
    }
    return dispatch({
      type: params.type,
      reduxType: REDUX_ACTION.SET,
      payload
    })
  }
}

export default setReduxAction
